export const findNextEnabledSection = (contentSectionCache, startIndex) => {
  for (let i = startIndex + 1; i < contentSectionCache?.length; i++) {
    if (contentSectionCache?.[i]) {
      return contentSectionCache[i].id;
    }
  }

  return null;
};

export const findPreviousEnabledSection = (contentSectionCache, startIndex) => {
  for (let i = startIndex - 1; i >= 0; i--) {
    if (contentSectionCache?.[i]) {
      return contentSectionCache[i].id;
    }
  }
  return null;
};
